import { render, staticRenderFns } from "./personalUpgrade__form.vue?vue&type=template&id=519c1a4d"
import script from "./personalUpgrade__form.vue?vue&type=script&lang=js"
export * from "./personalUpgrade__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports